import { Collapse } from 'antd';
import styled from 'styled-components';

// Panels divide at the header instead of antd's line above and below each panel's content.
export const CollapseV5 = styled(Collapse)`
  .ant-collapse-item:not([class*='PropagationPanel']) {
    border: none;
  }

  .ant-collapse-item:last-of-type:not(.ant-collapse-item-active) {
    .ant-collapse-header {
      border-bottom: unset;
    }
  }

  .ant-collapse-header {
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  }

  .ant-collapse-content {
    border: none !important;
  }
`;
